module.exports = __webpack_public_path__ + "img/star_rate_yellow.dba94345.svg";